import { useContext } from 'react';
import { FeatureFlagsContext } from '../../components/AuthorizedPageLoader';
import { Features } from '../../generated/hooks';

export const useFeatureFlag = (flag: Features) => {
  const featureFlags = useContext(FeatureFlagsContext);
  return featureFlags.includes(flag);
};
